import { QRCodeSVG } from "qrcode.react";

import type { TotpSetup } from "@lib/authentication/hooks/use-authentication/use-authentication.types";

// The authenticator secret as a QR code, with the key for anyone who cannot
// scan (OMG-2777). Shown at first sign-in to the admin pool and on
// /two-factor.
export const TotpSetupDetails = ({ setup }: { setup: TotpSetup }) => (
  <>
    <div className="mt-2 inline-block bg-white p-2">
      <QRCodeSVG value={setup.uri} size={176} />
    </div>
    <p className="mt-2 text-sm text-gray-600">
      Cannot scan? Add an account by key and enter:{" "}
      <code className="break-all font-mono">{setup.secret}</code>
    </p>
  </>
);
